import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const vistListEndpoint = ApiEndpoints.schedulevisit.scheduleList;

const tableHeader = ["date", "Vist Date", "Name", "email", "phone", "branch", "purpose", "message", "source URL"];
const tbody = ["createdAt", "date", "name", "email", "phoneNumber", "branch", "enquiry_purpose", "message", "source_url"];

export default function Contact() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", vistListEndpoint);
            const result = response.schedulevisits;
            setData(result);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);


    const pagename = {
      name: 'Schedule A Visit',
      user: 'Admin',
      innerpage: 'Schedule A Visit'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
